import React, { useState } from 'react'

import { branch } from 'baobab-react/higher-order'
import { bool } from 'prop-types'
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'

import NewModal from 'components/molecules/NewModal'

import BaseTemplate from 'components/templates/BaseTemplate'
import PeluangBanner from './PeluangBanner'
import PeluangTimer from './PeluangTimer'
import PeluangBenefit from './PeluangBenefit'
import PeluangFAQ from './PeluangFAQ'
import PeluangArticle from './PeluangArticle'
import PeluangFooter from './PeluangFooter'

const PeluangSBMPTNLanding = ({ has_ot_score: hasOTScore, has_submit_interest: hasSubmitInterest }) => {
  const [showModalOT, toggleModalOT] = useState(false)
  const [showModalMissedOT, toggleModalMissedOT] = useState(false)

  const onClickCTA = () => {
    const today = new Date()
    // open interest form for 8 - 17 Mar
    const openInterestForm = isAfter(today, new Date(2021, 2, 8)) && isBefore(today, new Date(2021, 2, 18))

    // open review form for 24 Mar - 2 Apr
    const openReviewForm = isAfter(today, new Date(2021, 2, 24)) && isBefore(today, new Date(2021, 3, 3))

    if (openInterestForm) {
      if (hasOTScore) {
        window.location.href = '/peluang-sbmptn/submit-interest'
      } else {
        toggleModalOT(true)
      }
    } else if (openReviewForm) {
      if (hasOTScore && hasSubmitInterest) {
        window.location.href = '/peluang-sbmptn/review'
      } else {
        toggleModalMissedOT(true)
      }
    } else {
      window.location.href = '#peluang-benefit'
    }
  }
  return (
    <BaseTemplate useNewHeader>
      <div className="peluang-landing">
        <PeluangBanner onClickCTA={() => onClickCTA()} />
        <PeluangBenefit />
        <PeluangTimer />
        <PeluangFAQ />
        <PeluangArticle />
        <PeluangFooter/>
        <NewModal
          isOpen={showModalOT}
          title="Data pengerjaan Tryoutmu belum lengkap!"
          message="Pastikan kamu sudah mengerjakan tryout TPS dan TKA sesuai dengan minat jurusanmu."
          cancel={{
            handle: () => toggleModalOT(false),
            text: 'Tutup',
          }}
          success={{
            handle: () => window.open('https://learn.quipper.com/en/dashboard', '_blank'),
            text: 'Ikuti',
          }}
        />
        <NewModal
          isOpen={showModalMissedOT}
          title="Hasil cek peluang SBMPTNmu tidak dapat ditemukan :("
          message="Hal ini disebabkan ketidak lengkapan nilai tryout dan/atau data universitas & jurusan pilihanmu."
          success={{
            handle: () => toggleModalMissedOT(false),
            text: 'Ok',
          }}
        />
      </div>
      <style jsx>
        {`
          .peluang-landing{
            color: #0C2846;
          }
        `}
      </style>
    </BaseTemplate>
  )
}

PeluangSBMPTNLanding.propTypes = {
  has_ot_score: bool,
}

export default branch({
  has_ot_score: ['serverProps', 'has_ot_score'],
  has_submit_interest: ['serverProps', 'has_submit_interest'],
}, PeluangSBMPTNLanding)
